import React from "react";

const CopyrightPolicyPage = () => {
  window.location.assign("https://1m-help-docs.s3.us-west-1.amazonaws.com/copyright-policy.html")
  return null
}

export default CopyrightPolicyPage